import React, { Component } from 'react';
import propTypes from 'prop-types';
import Select from 'react-select';
import pick from 'lodash/pick';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isArray from 'lodash/isArray';
import noop from 'lodash/noop';


export default class F2gSelect extends Component {

	constructor(props) {
		super(props);

		this.constructOptions = this.constructOptions.bind(this);
		this.constructValue = this.constructValue.bind(this);
		this.isSimpleMode = this.isSimpleMode.bind(this);
		this.onChange = this.onChange.bind(this);
		this.makeObjectForSelect = this.makeObjectForSelect.bind(this);
		this.defaultValueComponent = this.defaultValueComponent.bind(this);
	}

	getChildContext() {
		const { labelKey, valueKey } = this.props;
		return { labelKey, valueKey };
	}

	isSimpleMode() {
		const options = this.props.options;
		return (!isEmpty(options) && (isString(options[0]) || isNumber(options[0])));
	}

	constructValue(value) {
		if (isEmpty(value)) return value;

		return isArray(value) ? value.map(this.makeObjectForSelect) : this.makeObjectForSelect(value);
	}

	constructOptions(options) {
		if (isEmpty(options)) return options;

		return options.map(this.makeObjectForSelect);
	}

	makeObjectForSelect(value) {
		const { valueKey, labelKey } = this.props;
		return this.isSimpleMode() ? { [valueKey]: value, [labelKey]: value } : value
	}

	validateSelection(selected) {
		let { multi, valueKey, minSelection, maxSelection } = this.props;

		// if(minSelection === 'undefined'){
		// 	minSelection = 0;
		// }

		if (multi) {
			//if (selected.length >= minSelection) {
				return this.isSimpleMode() ? selected.map(v => v[valueKey]) : selected;
			//}
			//return null;
		}
		else {
			return this.isSimpleMode() ? selected[valueKey] : selected;
		}
	}

	onChange(selected) {
		const name = this.props.name;
		let value = this.validateSelection(selected);
		if (value !== null) {
			this.props.onChange(value, name);
		}
	}

	defaultValueComponent(props) {
		const { value, values } = props;
		const label = value[this.props.labelKey];
		const isLast = values ? value == values[values.length - 1] : true;
		return <span className="f2g-select-option">{label}{isLast ? '' : ', '}</span>
	}
	
	render() {
		const { maxHeight, maxWidth, valueComponent } = this.props;
		const options = this.constructOptions(this.props.options);
		const value = this.constructValue(this.props.value);

		const supportedProps = ['name', 'searchable', 'clearable', 'placeholder', 'disabled',
			'multi', 'optionComponent', 'valueKey', 'labelKey', 'closeOnSelect', 'className', 'defaultStyle'];

		const closeOnSelect = !this.props.multi;
		const props = pick(this.props, supportedProps);
		let placeholders = props.placeholder;
		let onBlur = props.onBlur

		let defaultStyle = false;
		if(this.props.defaultStyle) {
			defaultStyle = this.props.defaultStyle;
		}

		return (
			<div className={!defaultStyle ? "f2g-select " : '' + props.className} style={{ maxWidth, maxHeight }}>
				<Select closeOnSelect={closeOnSelect}
					{...props}
					placeholder={placeholders}
					options={options}
					value={value}
					onChange={this.onChange}
					valueComponent={valueComponent || this.defaultValueComponent}
					removeSelected={false}
					onBlur={onBlur}
				/>
			</div>
		)
	}
}

F2gSelect.propTypes = {
	placeholder: propTypes.string,
	options: propTypes.array, // array of objects or array of strings
	searchable: propTypes.bool,
	clearable: propTypes.bool,
	onChange: propTypes.func,
	onBlur: propTypes.any,
	multi: propTypes.bool,
	disabled: propTypes.bool,
	name: propTypes.string,
	optionComponent: propTypes.func,
	maxHeight: propTypes.string,
	maxWidth: propTypes.string,
	valueKey: propTypes.string,
	labelKey: propTypes.string,
	valueComponent: propTypes.func,
};

F2gSelect.defaultProps = {
	searchable: false,
	onChange: noop,
	clearable: true,
	maxHeight: '200px',
	valueKey: 'key',
	labelKey: 'value',
	placeholder: 'Select'	
};

F2gSelect.childContextTypes = {
	valueKey: propTypes.string,
	labelKey: propTypes.string,
};


// WEBPACK FOOTER //
// ./common/components/F2gSelect/F2gSelect.jsx